export const logInfo = (...messages: any[]): void => {
  if (process.env.NODE_ENV === "development") {
    console.log(...messages);
  }
};

export const logError = (...messages: any[]): void => {
    console.error(...messages);
};
